import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { AddToFavouriteBadge } from '../addToFavouriteBadge/addToFavouriteBadge.component';
import { MenuPosition } from '../menuPosition/menuPosition.component';
import { TextBox } from '../textBox/textBox.component';

import { ContainerProps } from './highlightSection.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  background-image:
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    url(${({ $backgroundImage }: ContainerProps): string => $backgroundImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 800px;
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  @media ${Breakpoint.Tablet} {
    height: 768px;
    padding: 32px;
  }

  @media ${Breakpoint.Mobile} {
    height: 1024px;
    padding: 20px;
  }

  @media ${Breakpoint.SmallMobile} {
    height: 720px;
  }
`;

export const HeaderSection: StyledComponent<'div'> = styled.div`
  z-index: ${ZIndex.Min};
`;

export const ButtonContainer: StyledComponent<typeof MenuPosition> = styled(MenuPosition)``;

export const Header: StyledComponent<'h2'> = styled.h2`
  font-weight: ${FontWeight.Medium};
  font-size: 40px;
  line-height: 44px;
  letter-spacing: -0.01em;
  color: ${Color.White};
  max-width: 740px;

  & + ${ButtonContainer} {
    margin-top: 32px;
  }

  @media ${Breakpoint.SmallMobile} {
    font-size: 30px;
    line-height: 38px;
  }
`;

export const StyledAddToFavouriteBadge: StyledComponent<typeof AddToFavouriteBadge> = styled(AddToFavouriteBadge)``;

export const StyledTextBox: StyledComponent<typeof TextBox> = styled(TextBox)`
  ${StyledAddToFavouriteBadge} + & {
    margin-left: 10px;

    @media ${Breakpoint.Mobile} {
      margin-left: 0;
      margin-top: 10px;
    }
  }
`;

export const BottomSection: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const TopOverlayMask: StyledComponent<'div'> = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.1) 50.95%, rgba(0, 0, 0, 0) 100%);
`;

export const CircleBackgroundItem: StyledComponent<'img'> = styled.img`
  position: absolute;
  top: -78px;
  left: 0;
  z-index: ${ZIndex.Zero};
  height: 452px;

  @media ${Breakpoint.SmallMobile} {
    height: 390px;
  }
`;

export const BottomSectionWrapper: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
